'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteThumbnail = exports.putContentAttributes = exports.createCategory = exports.editRecordingTitle = exports.registerForContent = exports.createThumbnail = exports.getContentAttributes = exports.WN_CONTENTS_ERROR_HANDLED = exports.REGISTER_FOR_CONTENT_FAILURE = exports.REGISTER_FOR_CONTENT_COMPLETE = exports.REGISTER_FOR_CONTENT_START = exports.PUT_CONTENT_ATTRIBUTE_FAILURE = exports.PUT_CONTENT_ATTRIBUTE_COMPLETE = exports.PUT_CONTENT_ATTRIBUTE_START = exports.GET_CONTENT_ATTRIBUTE_FAILURE = exports.GET_CONTENT_ATTRIBUTE_COMPLETE = exports.GET_CONTENT_ATTRIBUTE_START = exports.WN_DELETE_THUMBNAIL_FAILURE = exports.WN_DELETE_THUMBNAIL_COMPLETE = exports.WN_DELETE_THUMBNAIL_START = exports.WN_CREATE_CATEGORY_FAILURE = exports.WN_CREATE_CATEGORY_COMPLETE = exports.WN_CREATE_CATEGORY_START = exports.WN_CREATE_THUMBNAIL_FAILURE = exports.WN_CREATE_THUMBNAIL_COMPLETE = exports.WN_CREATE_THUMBNAIL_START = exports.WN_UPDATE_RECORDING_TITLE_FAILURE = exports.WN_UPDATE_RECORDING_TITLE_COMPLETE = exports.WN_UPDATE_RECORDING_TITLE_START = exports.GET_ONE_CONTENT_FAILURE = exports.GET_ONE_CONTENT_COMPLETE = exports.GET_ONE_CONTENT_START = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getOneContent = getOneContent;
exports.contentErrorHandled = contentErrorHandled;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var GET_ONE_CONTENT_START = exports.GET_ONE_CONTENT_START = 'GET_ONE_CONTENT_START';
var GET_ONE_CONTENT_COMPLETE = exports.GET_ONE_CONTENT_COMPLETE = 'GET_ONE_CONTENT_COMPLETE';
var GET_ONE_CONTENT_FAILURE = exports.GET_ONE_CONTENT_FAILURE = 'GET_ONE_CONTENT_FAILURE';

var WN_UPDATE_RECORDING_TITLE_START = exports.WN_UPDATE_RECORDING_TITLE_START = 'UPDATE_RECORDING_TITLE_START';
var WN_UPDATE_RECORDING_TITLE_COMPLETE = exports.WN_UPDATE_RECORDING_TITLE_COMPLETE = 'UPDATE_RECORDING_TITLE_COMPLETE';
var WN_UPDATE_RECORDING_TITLE_FAILURE = exports.WN_UPDATE_RECORDING_TITLE_FAILURE = 'UPDATE_RECORDING_TITLE_FAILURE';

var WN_CREATE_THUMBNAIL_START = exports.WN_CREATE_THUMBNAIL_START = 'CREATE_THUMBNAIL_START';
var WN_CREATE_THUMBNAIL_COMPLETE = exports.WN_CREATE_THUMBNAIL_COMPLETE = 'CREATE_THUMBNAIL_COMPLETE';
var WN_CREATE_THUMBNAIL_FAILURE = exports.WN_CREATE_THUMBNAIL_FAILURE = 'CREATE_THUMBNAIL_FAILURE';

var WN_CREATE_CATEGORY_START = exports.WN_CREATE_CATEGORY_START = 'CREATE_CATEGORY_START';
var WN_CREATE_CATEGORY_COMPLETE = exports.WN_CREATE_CATEGORY_COMPLETE = 'CREATE_CATEGORY_COMPLETE';
var WN_CREATE_CATEGORY_FAILURE = exports.WN_CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';

var WN_DELETE_THUMBNAIL_START = exports.WN_DELETE_THUMBNAIL_START = 'DELETE_THUMBNAIL_START';
var WN_DELETE_THUMBNAIL_COMPLETE = exports.WN_DELETE_THUMBNAIL_COMPLETE = 'DELETE_THUMBNAIL_COMPLETE';
var WN_DELETE_THUMBNAIL_FAILURE = exports.WN_DELETE_THUMBNAIL_FAILURE = 'DELETE_THUMBNAIL_FAILURE';

var GET_CONTENT_ATTRIBUTE_START = exports.GET_CONTENT_ATTRIBUTE_START = 'GET_CONTENT_ATTRIBUTE_START';
var GET_CONTENT_ATTRIBUTE_COMPLETE = exports.GET_CONTENT_ATTRIBUTE_COMPLETE = 'GET_CONTENT_ATTRIBUTE_COMPLETE';
var GET_CONTENT_ATTRIBUTE_FAILURE = exports.GET_CONTENT_ATTRIBUTE_FAILURE = 'GET_CONTENT_ATTRIBUTE_FAILURE';

var PUT_CONTENT_ATTRIBUTE_START = exports.PUT_CONTENT_ATTRIBUTE_START = 'PUT_CONTENT_ATTRIBUTE_START';
var PUT_CONTENT_ATTRIBUTE_COMPLETE = exports.PUT_CONTENT_ATTRIBUTE_COMPLETE = 'PUT_CONTENT_ATTRIBUTE_COMPLETE';
var PUT_CONTENT_ATTRIBUTE_FAILURE = exports.PUT_CONTENT_ATTRIBUTE_FAILURE = 'PUT_CONTENT_ATTRIBUTE_FAILURE';

var REGISTER_FOR_CONTENT_START = exports.REGISTER_FOR_CONTENT_START = 'REGISTER_FOR_CONTENT_START';
var REGISTER_FOR_CONTENT_COMPLETE = exports.REGISTER_FOR_CONTENT_COMPLETE = 'REGISTER_FOR_CONTENT_COMPLETE';
var REGISTER_FOR_CONTENT_FAILURE = exports.REGISTER_FOR_CONTENT_FAILURE = 'REGISTER_FOR_CONTENT_FAILURE';

// error handling for thumbnails and event category
var WN_CONTENTS_ERROR_HANDLED = exports.WN_CONTENTS_ERROR_HANDLED = 'CONTENTS_ERROR_HANDLED';

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------

var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-content');
    }
    logger.error(msg, attributes);
}

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Bearer ' + state.auth.authInfo.access_token;
    }

    return header;
}

// ------------------------------------------------------------------ READ CALLS ------------------------------------------------------------------

function getOneContent(contentKey, needsAuth) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents?ids=' + contentKey;
        var state = getState();
        var header = needsAuth ? getheader(state) : getheader();

        // return the content corresponding to the contentkey from the state if present
        var content = null;
        if (state.contents.data.length > 0) {
            var newContent = state.contents.data.filter(function (item) {
                return contentKey === item.id;
            });
            content = [Object.assign({}, newContent[0])];
        }
        dispatch({ type: GET_ONE_CONTENT_START });
        if (content) {
            dispatch({ type: GET_ONE_CONTENT_COMPLETE, content: content });
            return true;
        }
        return HTTP.getData(contentServiceUrl, header).then(function (response) {
            dispatch({ type: GET_ONE_CONTENT_COMPLETE, content: response });
        }).catch(function (error) {
            loggingHelper('failed to get a single content', { method: 'getOneContent', callType: 'GET', contentKey: contentKey, needsAuth: needsAuth, error: error });
            dispatch({ type: GET_ONE_CONTENT_FAILURE, error: error });
        });
    };
}

var getContentAttributes = exports.getContentAttributes = function getContentAttributes(contentId, attributes) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/attributes?key=' + attributes;

        dispatch({ type: GET_CONTENT_ATTRIBUTE_START });

        return HTTP.getData(contentServiceUrl).then(function (content) {
            dispatch({ type: GET_CONTENT_ATTRIBUTE_COMPLETE, content: content });
        }).catch(function (error) {
            loggingHelper('failed to get the content attributes', { method: 'getContentAttributes', callType: 'GET', contentId: contentId, attributes: attributes, error: error });
            dispatch({ type: GET_CONTENT_ATTRIBUTE_FAILURE, error: error, dataCall: 'getContentAttribute' });
        });
    };
};

function getRegistrationInfo(contentId) {
    return function (registrantInfo) {
        if (!registrantInfo || !registrantInfo.registrantKey) {
            throw new Error('no registrant info present');
        }

        var registrantKey = registrantInfo.registrantKey;
        var getRecordingPlayUrl = config().broker.g2w.baseURL + '/api/V2/webinars/' + contentId + '/registrants/' + registrantKey + '/recordings/' + contentId;
        var header = getheader();

        return HTTP.getData(getRecordingPlayUrl, header);
    };
}

// ------------------------------------------------------------------ CREATE CALLS ------------------------------------------------------------------

var createThumbnail = exports.createThumbnail = function createThumbnail(contentId, thumbnailInfo) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/thumbnails';
        var state = getState();
        var header = getheader(state);

        dispatch({ type: WN_CREATE_THUMBNAIL_START });

        return HTTP.postData(contentServiceUrl, header, thumbnailInfo).then(function (content) {
            dispatch({ type: WN_CREATE_THUMBNAIL_COMPLETE, content: content, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to create a new thumbnail', { method: 'createThumbnail', callType: 'POST', contentId: contentId, thumbnailInfo: thumbnailInfo, error: error });
            dispatch({ type: WN_CREATE_THUMBNAIL_FAILURE, error: error, dataCall: 'postContentThumbnail' });
        });
    };
};

var registerForContent = exports.registerForContent = function registerForContent(contentId, attributes) {
    var registerUrl = config().broker.g2w.baseURL + '/api/recordings/' + contentId + '/registrants';

    return function (dispatch, getState) {
        var acceptStatus = 409;
        var header = getheader();

        dispatch({ type: REGISTER_FOR_CONTENT_START });

        return HTTP.postData(registerUrl, header, attributes, acceptStatus).then(getRegistrationInfo(contentId)).then(function (registrationInfo) {
            dispatch({ type: REGISTER_FOR_CONTENT_COMPLETE, registrationInfo: _extends({}, registrationInfo, attributes) });
        }).catch(function (err) {
            loggingHelper('failed to register for a content', { method: 'registerForContent', callType: 'POST', contentId: contentId, attributes: attributes, err: err });
            dispatch({ type: REGISTER_FOR_CONTENT_FAILURE, err: err, dataCall: 'postContentRegister' });
        });
    };
};

// ------------------------------------------------------------------ UPDATE CALLS ------------------------------------------------------------------

var editRecordingTitle = exports.editRecordingTitle = function editRecordingTitle(contentId, fileTitleInfo) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId;
        var state = getState();
        var header = getheader(state);

        dispatch({ type: WN_UPDATE_RECORDING_TITLE_START });

        return HTTP.putData(contentServiceUrl, header, fileTitleInfo).then(function (content) {
            dispatch({ type: WN_UPDATE_RECORDING_TITLE_COMPLETE, content: content, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to edit a recording title', { method: 'editRecordingTitle', callType: 'PUT', contentId: contentId, fileTitleInfo: fileTitleInfo, error: error });
            dispatch({ type: WN_UPDATE_RECORDING_TITLE_FAILURE, error: error, dataCall: 'putRecordingTitle' });
        });
    };
};

var createCategory = exports.createCategory = function createCategory(contentId, category) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId;
        var state = getState();
        var header = getheader(state);

        if (category.category === 'GENERAL') {
            category.category = null;
        }

        dispatch({ type: WN_CREATE_CATEGORY_START });

        return HTTP.putData(contentServiceUrl, header, category).then(function (content) {
            dispatch({ type: WN_CREATE_CATEGORY_COMPLETE, content: content });
        }).catch(function (error) {
            loggingHelper('failed to update the category for a recording', { method: 'createCategory', callType: 'PUT', contentId: contentId, category: category, error: error });
            dispatch({ type: WN_CREATE_CATEGORY_FAILURE, error: error, dataCall: 'putContentCategory' });
        });
    };
};

var putContentAttributes = exports.putContentAttributes = function putContentAttributes(contentId, attributes) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/attributes';
        var store = getState();
        var header = getheader(store);

        dispatch({ type: PUT_CONTENT_ATTRIBUTE_START });

        return HTTP.putData(contentServiceUrl, header, attributes).then(function (content) {
            dispatch({ type: PUT_CONTENT_ATTRIBUTE_COMPLETE, attributes: attributes });
        }).catch(function (error) {
            loggingHelper('failed to update the attributes for a recording', { method: 'putContentAttributes', callType: 'PUT', contentId: contentId, attributes: attributes, error: error });
            dispatch({ type: PUT_CONTENT_ATTRIBUTE_FAILURE, error: error, dataCall: 'putContentAttribute' });
        });
    };
};

// ------------------------------------------------------------------ UPDATE CALLS ------------------------------------------------------------------
var deleteThumbnail = exports.deleteThumbnail = function deleteThumbnail(contentId) {
    return function (dispatch, getState) {
        var contentServiceUrl = baseUrl() + '/contents/' + contentId + '/thumbnails';
        var store = getState();
        var header = getheader(store);

        dispatch({ type: WN_DELETE_THUMBNAIL_START });

        return HTTP.deleteData(contentServiceUrl, header).then(function () {
            dispatch({ type: WN_DELETE_THUMBNAIL_COMPLETE, contentId: contentId });
        }).catch(function (error) {
            loggingHelper('failed to delete a recording thumbnail', { method: 'deleteThumbnail', callType: 'DELETE', contentId: contentId, error: error });
            dispatch({ type: WN_DELETE_THUMBNAIL_FAILURE, error: error, dataCall: 'deleteContentThumbnail' });
        });
    };
};

function contentErrorHandled() {
    return function (dispatch) {
        dispatch({ type: WN_CONTENTS_ERROR_HANDLED });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/content.js
// module id = 784
// module chunks = 0